const DATABASE_NAME = 'guidesofia-media-package';
const DATABASE_VERSION = 1;
const STORE_NAME = 'drafts';

const openDatabase = () => new Promise((resolve, reject) => {
  if (!window.indexedDB) {
    reject(new Error('This browser does not support persistent media drafts.'));
    return;
  }
  const request = window.indexedDB.open(DATABASE_NAME, DATABASE_VERSION);
  request.onupgradeneeded = () => {
    const database = request.result;
    if (!database.objectStoreNames.contains(STORE_NAME)) {
      database.createObjectStore(STORE_NAME, { keyPath: 'guideKey' });
    }
  };
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error || new Error('Persistent media storage could not be opened.'));
});

const runTransaction = async (mode, operation) => {
  const database = await openDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, mode);
      const store = transaction.objectStore(STORE_NAME);
      const request = operation(store);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error || new Error('Persistent media storage operation failed.'));
      transaction.onabort = () => reject(transaction.error || new Error('Persistent media storage transaction was aborted.'));
    });
  } finally {
    database.close();
  }
};

export const loadMediaPackageDraft = (guideKey) => runTransaction('readonly', (store) => store.get(guideKey));

export const saveMediaPackageDraft = (guideKey, draft) => runTransaction('readwrite', (store) => store.put({
  guideKey,
  packageData: draft.packageData,
  localCampaignImage: draft.localCampaignImage || '',
  localPartnerLogo: draft.localPartnerLogo || '',
  localPhoneFrame: draft.localPhoneFrame || '',
  localPhoneScreen: draft.localPhoneScreen || '',
  localVideoMedia: draft.localVideoMedia || null,
  cloudAssets: draft.cloudAssets || {},
  updatedAt: new Date().toISOString(),
}));
